import { ListItem, Section } from '@/components';
import { useWalletsContext } from '@/components/providers/postauth/UserWalletsProvider';
import { formatNumberToAmountInUsdString } from '@/utils/formatUtils';
import { FC } from 'react';
import { LiaCoinsSolid } from 'react-icons/lia';
interface Props {
  label?: string;
  deployedValue?: number;
  returnRate?: number | null;
}
const CoinsIcon = LiaCoinsSolid as React.ComponentType<any>;
const AssetsDeployedSection: FC<Props> = ({
  label = 'Assets',
  deployedValue,
}) => {
  const { underlyingYieldBearingAssets } = useWalletsContext();
  const totalUnderlyingValue =
    deployedValue ??
    underlyingYieldBearingAssets.reduce(
      (sum, asset) => sum + (asset.balanceInUsd || 0),
      0,
    );
  return (
    <Section
      body={
        <ListItem
          leftIcon={<CoinsIcon className="text-secondary" />}
          leftIconWidth={33}
          leftIconHeight={33}
          mainText={
            totalUnderlyingValue !== null
              ? formatNumberToAmountInUsdString(totalUnderlyingValue)
              : null
          }
          mainTextColor="primary"
          subText={label}
          subTextSize="caption"
        />
      }
    />
  );
};
export default AssetsDeployedSection;
